import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import queryClient from '@app/queryClient';
import { t } from 'i18next';
import { opportunitiesApi } from '../api';

const useDeleteOpportunityApplicant = (oppId: string) => {
  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['deleteOpportunityApplicant', oppId],
    mutationFn: (data: { applicantId: string }) =>
      opportunitiesApi.deleteOppApplicant(oppId, data.applicantId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clientOpportunity', oppId] });
      queryClient.invalidateQueries({ queryKey: ['vaultConfig', oppId] });
      toast('info', { message: t('opportunity.mutations.applicantDeletedSuccess') });
    },
    onError: () => {
      toast('error', { message: t('opportunity.mutations.applicantDeletedFail') });
    },
  });

  return {
    mutate, error, isPending, mutateAsync,
  };
};

export default useDeleteOpportunityApplicant;
